import { Spine } from '../components/spine';
import { matricesByGameId } from '../../constants/enumsByGames';
import { gameConfigurationStore } from '../store/gameConfigurationStore';

// RU: спайны линий выигрыша — по одному на каждую линию игры, и кости каждой линии
//     (позиции по барабанам), отсортированные слева направо.
class GameResourcesService {
  allLinesSpine = [];

  allWinLinesBone = [];

  setupAllLine(parentContainer) {
    const { WinningLinesCoordinate } = matricesByGameId[gameConfigurationStore.gameId];
    WinningLinesCoordinate.forEach(() => {
      const winLine = new Spine({ key: 'winLine' });
      winLine.visible = false;
      this.allLinesSpine.push(winLine);
      parentContainer.addChild(winLine);
    });
    this.allWinLinesBone = this.allLinesSpine.map((el) =>
      el.skeleton.bones
        .filter((bone) => bone.data.name.includes('bone'))
        .sort((a, b) => (a.x > b.x ? 1 : b.x > a.x ? -1 : 0))
    );
  }
}

export const gameResourcesService = new GameResourcesService();
